/**
 * RU-M4-H2 ML-7 (M4-09): one label for a displayed price.
 *
 * p: { ltp, is_live, age_sec, source, simulated, _rx }  (`_rx` = client receipt time in ms, when known)
 * Returns "SIMULATED" | "LIVE" | "DELAYED" | null (no price).
 */
export const LIVE_MAX_AGE_S = 180;

export function priceLabel(p, nowMs = Date.now()) {
  if (!p || p.ltp === null || p.ltp === undefined) return null;
  if (p.simulated === true || String(p.source || "").includes("mock")) return "SIMULATED";
  if (p.is_live !== true) return "DELAYED";
  const base = typeof p.age_sec === "number" ? p.age_sec : 0;
  const since = typeof p._rx === "number" ? Math.max(0, (nowMs - p._rx) / 1000) : 0;
  return base + since <= LIVE_MAX_AGE_S ? "LIVE" : "DELAYED";
}

/** RU-SIGTAGAGE TA-1: stamp each fetched row with its browser receipt time (`_rx`, ms). */
export function stampRx(items, nowMs = Date.now()) {
  return Array.isArray(items) ? items.map((r) => ({ ...r, _rx: nowMs })) : [];
}

/**
 * Signals / watchlist rows: `ltp_*` fields from the API. Null when live or no price.
 * RU-SIGTAGAGE TA-2: with `_rx` (see stampRx) the row's server age keeps growing client-side.
 */
export function ltpTag(row, nowMs = Date.now()) {
  if (!row || row.ltp === null || row.ltp === undefined) return null;
  const lab = priceLabel({
    ltp: row.ltp, is_live: row.ltp_is_live, age_sec: row.ltp_age_sec, source: row.ltp_source, _rx: row._rx,
  }, nowMs);
  return lab === "LIVE" ? null : lab;
}

/** Ticker badge: LIVE only when connected and at least one shown tick is LIVE. */
export function tickerBadge(connected, ticks, symbols, nowMs = Date.now()) {
  if (!connected) return null;
  const anyLive = (symbols || []).some((s) => priceLabel(ticks?.[s], nowMs) === "LIVE");
  return anyLive ? "LIVE" : "DELAYED";
}
